import React from 'react'
import {Icon} from '@chakra-ui/react'

const ShareIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" id="share" {...props}>
            <path
                d="M18.6066 7.87577C16.5996 7.87577 14.9658 6.24196 14.9658 4.23503C14.9658 2.2281 16.5996 0.599945 18.6066 0.599945C20.6135 0.599945 22.2473 2.23375 22.2473 4.24068C22.2473 6.24761 20.6135 7.88142 18.6066 7.88142V7.87577ZM18.6066 1.73061C17.2215 1.73061 16.0965 2.85562 16.0965 4.24068C16.0965 5.62575 17.2215 6.75076 18.6066 6.75076C19.9916 6.75076 21.1166 5.62575 21.1166 4.24068C21.1166 2.85562 19.9916 1.73061 18.6066 1.73061Z"
                fill="currentColor"
            />
            <path
                d="M18.6066 23.4394C16.5996 23.4394 14.9658 21.8056 14.9658 19.7986C14.9658 17.7917 16.5996 16.1579 18.6066 16.1579C20.6135 16.1579 22.2473 17.7917 22.2473 19.7986C22.2473 21.8056 20.6135 23.4394 18.6066 23.4394ZM18.6066 17.2942C17.2215 17.2942 16.0965 18.4192 16.0965 19.8043C16.0965 21.1894 17.2215 22.3144 18.6066 22.3144C19.9916 22.3144 21.1166 21.1894 21.1166 19.8043C21.1166 18.4192 19.9916 17.2942 18.6066 17.2942Z"
                fill="currentColor"
            />
            <path
                d="M4.84093 15.7C2.834 15.7 1.2002 14.0662 1.2002 12.0592C1.2002 10.0523 2.834 8.4185 4.84093 8.4185C6.84786 8.4185 8.48167 10.0523 8.48167 12.0592C8.48167 14.0662 6.84786 15.7 4.84093 15.7ZM4.84093 9.55482C3.45587 9.55482 2.33086 10.6798 2.33086 12.0649C2.33086 13.45 3.45587 14.575 4.84093 14.575C6.226 14.575 7.35101 13.45 7.35101 12.0649C7.35101 10.6798 6.226 9.55482 4.84093 9.55482Z"
                fill="currentColor"
            />
            <path
                d="M7.66788 11.0529C7.47002 11.0529 7.27781 10.9512 7.17605 10.7646C7.02341 10.4932 7.11951 10.1484 7.39087 9.99576L15.4921 5.40526C15.7634 5.25262 16.1083 5.34873 16.2609 5.62009C16.4136 5.89145 16.3175 6.2363 16.0461 6.38894L7.9449 10.9794C7.85444 11.0303 7.76399 11.0529 7.66788 11.0529Z"
                fill="currentColor"
            />
            <path
                d="M15.8082 18.8149C15.7121 18.8149 15.6216 18.7923 15.5312 18.7414L7.35083 14.1509C7.07947 13.9983 6.98337 13.6534 7.13601 13.3821C7.28865 13.1107 7.6335 13.0146 7.90486 13.1673L16.0852 17.7578C16.3566 17.9104 16.4527 18.2552 16.3 18.5266C16.1983 18.7132 16.0061 18.8149 15.8082 18.8149Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ShareIcon
